<template>
  <div class="product-details-container">
    <div v-if="!linkUrl">
      <div class="product-content">
        <img v-if="productInfo.productUrl" class="product-img" :src="productInfo.productUrl" alt="" @click="imgPreview(productInfo.productUrl)">
        <img v-else class="product-img" src="@/assets/images/icon_noimg.png" alt="">
        <div class="product-name">产品：{{ productInfo.productName }}</div>
        <div class="welfare-info">限时福利：该产品可获得<span class="tips">{{ activityInfo.rewardName }}</span></div>
        <van-field v-model="snCode" label="" placeholder="Product Code">
          <template #right-icon>
            <van-icon size="20" name="scan" @click.stop="handleScan" />
          </template>
        </van-field>
      </div>
      <div class="uploader-field">
        <div>Sales receipt：</div>
        <van-uploader v-model="salesImgUrl" max-count="1" :after-read="(files, detail) => afterRead(files, detail)" :before-read="beforeRead" @delete="(files, detail) => handleDelete(files, detail, 'salesImgUrl')" />
      </div>
      <div class="btn-content">
        <van-button type="warning" class="claim-btn" @click="handleClaim">领取奖品</van-button>
      </div>
    </div>
    <div class="last-confirm" v-else>
      <div class="confirm-tips">是否已领取奖励?</div>
      <div class="confirm-btn">
        <van-button type="warning" class="claim-btn" @click="handleReceive('yes')">已领取</van-button>
        <van-button type="warning" class="claim-btn to-claim-btn" @click="handleReceive('no')">否，去领取</van-button>
      </div>
    </div>
    <van-popup v-model="showScanner" position="bottom" :style="{ height: '100%' }">
      <barcode-scanner v-if="showScanner" @on-scan-success="onScanSuccess" @close="onScanClose" scanType="activityProduct" />
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import { awardOrderApi } from '@/api'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'ActivityProduct',
  components: {
    BarcodeScanner
  },
  data() {
    return {
      snCode: '',
      barcode: '',
      showScanner: false,
      productInfo: {},
      salesImgUrl: [],
      linkUrl: ''
    };
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo',
      activityInfo: 'activityInfo'
    })
  },
  created() {
    this.barcode = this.$route.query.barcode || '';
    this.productInfo = {}
    if (localStorage.getItem('productInfo')) {
      this.productInfo = JSON.parse(localStorage.getItem('productInfo'))
    }
    let linkUrl = localStorage.getItem('linkUrl')
    this.linkUrl = linkUrl || ''
  },
  methods: {
    afterRead(files, detail) {
			Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
		  this.$uploadImg(files).then(res => {
				Toast.clear()
				this.$set(this.salesImgUrl, detail.index, { url: res.url })
			}).catch((err) => {
				this.salesImgUrl.splice(detail.index, 1)
				Toast('Upload Failed')
			})
    },
    beforeRead(file) {
			return this.$imageCompression(file).then(res => {
				return res
			})
    },
    handleDelete(files, detail, key) {
			// console.log('handleDelete', this.storeForm)
			// this.storeForm[key].splice(detail.index, 1)
		},
    handleReceive(type) {
      if (type === 'yes') {
        this.$router.push('/activity')
      } else {
        window.open(this.linkUrl, '_blank');
      }
    },
    handleClaim() {
      // this.$router.push('/prizeDetail')
      if (!this.salesImgUrl[0] || !this.snCode) {
        Toast('请完善信息！！！')
        return
      }
      const data = {
        salesImgUrl: this.salesImgUrl[0].url,
        snCode: this.snCode,
        code: this.barcode,
        customerKey: this.userInfo.customerKey
      }
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      const newWindow = window.open('', '_blank')
      awardOrderApi(data).then(res => {
        Toast.clear()
        localStorage.setItem('linkUrl', res.data.linkUrl)
        this.linkUrl = res.data.linkUrl
        newWindow.location.href = res.data.linkUrl;
      }).catch(() => {
        newWindow.close()
      })
    },
    handleScan() {
      this.showScanner = true;
    },
    onScanSuccess(code) {
      this.snCode = code;
      this.showScanner = false;
    },
    onScanClose() {
      this.showScanner = false;
    },
    imgPreview(url) {
      ImagePreview({
        images: [url]
      })
    }
  }
};
</script>

<style lang="less" scoped>
.product-details-container {
  padding: 20px;
  height: 100vh;
  background-color: #f2f2f2;
  .product-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 80px;
  }
  .product-img {
    width: 100px;
    height: 100px;
  }
  .product-name {
    font-weight: bold;
    margin: 20px 0;
  }
  .welfare-info {
    font-size: 12px;
    margin-bottom: 10px;
    .tips {
      color: #ee541b;
      font-size: 12px;
    }
  }
  /deep/.van-field {
    padding: 5px 10px;
    margin-top: 10px;
    margin-bottom: 30px;
    border: 1px solid #dce5f6;
    border-radius: 10px;
  }
  .uploader-field {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    /deep/.van-uploader__upload {
      width: 60px;
      height: 60px;
      margin: 0;
      border: 1px solid #dce5f6;
    }
  }
  .btn-content,
  .confirm-btn {
    text-align: center;
    .claim-btn {
      width: 126px;
      background-color: #ee541b;
      border-radius: 10px;
      border: none;
    }
  }
  .last-confirm {
    padding-top: 80px;
    text-align: center;
    .confirm-tips {
      font-size: 16px;
    }
    .confirm-btn {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 100px;
      .claim-btn {
        width: 166px;
        margin-bottom: 20px;
      }
      .to-claim-btn {
        background-color: #fff;
        color: #ee541b;
        border: 1px solid #ee541b;;
      }
    }
  }
}
</style>
